import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	complaintForms: [],
};

// active account slice
export const allComplaintFormsSlice = createSlice({
	name: 'complaintForms',
	initialState,
	reducers: {
		setAllComplaintForms: (state, action) => {
			state.complaintForms = action.payload;
		},
	},
});

export const {
	setAllComplaintForms,
} = allComplaintFormsSlice.actions;

export default allComplaintFormsSlice.reducer;
